var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-table', {
    staticClass: "m-0",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.items,
      "small": ""
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }